module.exports = __webpack_public_path__ + "img/chat_icon2.5c3f46ce.png";